module.exports = __webpack_public_path__ + "img/bf02b94.png";